import { render, staticRenderFns } from "./SchemaPropertyField.vue?vue&type=template&id=70d39b6f&"
import script from "./SchemaPropertyField.vue?vue&type=script&lang=js&"
export * from "./SchemaPropertyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports